import { USER_KIND_USER } from "~/constants/userKinds";
import type { User } from "~/shared/types";

export const isAgentUser = (user: User) => user.kind !== USER_KIND_USER;

export const getUserDisplayName = (user: User): string => {
  if (isAgentUser(user)) {
    return user.name?.trim() ?? "(Unknown)";
  }
  return user.name?.trim() || user.email;
};
